import { EntityAudit } from "@modernary/mui/components/audit";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  asbestosNotifications: "AsbestosNotification.AsbestosNotifications",
  list: "AsbestosNotification.AsbestosNotificationList",
  base: "AsbestosNotification.AsbestosNotificationBase",
  view: "AsbestosNotification.AsbestosNotificationView",
  audit: "AsbestosNotification.AsbestosNotificationAudit",
};

export { names as asbestosNotificationRouteNames };

const asbestosNotificationRoutes: RouterOptions["routes"] = [
  {
    path: "/asbestosNotification",
    name: names.asbestosNotifications,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Asbestos Notifications",
          lookupGroups: ["AsbestosUnit", "AsbestosMaterialType"],
        },
        component: () => import("@/views/asbestosNotifications/AsbestosNotificationList.vue"),
      },

      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/asbestosNotifications/AsbestosNotificationBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Asbestos Notification View" },
            component: () => import("@/views/asbestosNotifications/AsbestosNotificationView.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Asbestos Notification Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="AsbestosNotification" />,
            },
          },
        ],
      },
    ],
  },
];
export default asbestosNotificationRoutes;
